{
  "ChangeLang_Title": "Sprache ändern",
  "ChangeLang_Subtitle": "Wählen Sie die Sprache aus, in der Sie den Webseiteninhalt während Ihrer aktuellen Websitzung auf diesem Computer anzeigen möchten.",
  "ChangeLang_Field_Label": "Sprache",
  "ChangeLang_Remember_Label": "Meine Auswahl merken",
  "ChangeLang_Buttons_Apply": "Anwenden",
  "ChangeLang_Buttons_Cancel": "Stornieren",
  "NAME": "ChangeLangLanguage"
}